import { Box, Divider } from "@mui/joy";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { useProject } from "../../../../hooks/query";
import { IProjectList } from "../../../../interfaces";

import { Title } from "./Title";
import { StatusGraph } from "./StatusGraph";
import { DataGrid } from "../../..";

import { columnDef } from "./column-def";

export default function ListProject() {
    const { useList } = useProject();
    const projectListSvc = useList();
    const navigate = useNavigate();

    const [projects, setProjects] = useState<IProjectList[]>([]);

    const fetchData = async () => {
        try {
            const response = await projectListSvc.mutateAsync();
            setProjects(response);
        } catch (e) {
            console.error("Error fetching data", e);
        }
    };

    const handleRowClicked = (event: any) => {
        navigate(`/project/list/${event.data.Id}`);
    };

    useEffect(() => {
        fetchData().then();
    }, []);

    return (
        <Box flex={1} display={"flex"} flexDirection={"column"} position={"relative"}>
            <Box mx={3} mt={3}>
                <Title onRefreshClick={fetchData} svc={projectListSvc} />
            </Box>
            <Divider sx={{ mt: 3 }} />
            <Box mx={3} mt={3}>
                <StatusGraph />
            </Box>
            <Divider sx={{ mt: 2 }} />
            <Box flex={1}>
                <DataGrid
                    gridData={projects}
                    columnDefs={columnDef}
                    hideHeader={true}
                    suppressCellFocus={true}
                    onRowClicked={handleRowClicked}
                    rowHeight={70}
                    rowStyle={{
                        cursor: "pointer",
                    }}
                />
            </Box>
        </Box>
    );
}
